import { FC } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import useRouter from 'use-react-router';
import Button from 'jbc-front/components/Button';
import { useEmployeeMutation as useMutation } from '@jbc-year-end-adj/2024/hooks/graphql/useMutation';
import { Widow as WidowTemplate } from '@jbc-year-end-adj/2024/features/questions/templates/Widow';
import { ButtonContainer } from '@jbc-year-end-adj/2024/features/questions/components/ButtonContainer';
import { Question } from '@jbc-year-end-adj/2024/features/questions/types';
import { Profile } from './query';
import { schema, Schema, buildDefaultValue, Classification } from './schema';
import { ANSWER_WIDOW } from './mutation';

type FormProps = {
  question: Question;
  profile: Profile;
};

export const Form: FC<FormProps> = ({ question, profile }) => {
  const { history } = useRouter();
  const [answer] = useMutation(ANSWER_WIDOW);
  const { setValue, watch } = useForm<Schema>({
    resolver: yupResolver(schema),
    defaultValues: buildDefaultValue(profile)
  });

  const maritalStatus = watch('maritalStatus');
  const classification = watch('classification');

  const handleSubmitMaritalStatus = async () => {
    await answer({
      variables: {
        input: {
          maritalStatus: 'married',
          classification: 'none'
        }
      }
    });
    history.push('/employee_input');
  };

  const handleSubmitClassification = async (value: Classification) => {
    await answer({
      variables: {
        input: {
          maritalStatus,
          classification: value
        }
      }
    });
    history.push('/employee_input');
  };

  return (
    <WidowTemplate>
      <WidowTemplate.CheckSpouse question={question}>
        <ButtonContainer>
          <Button
            huge
            primary={!maritalStatus || maritalStatus === 'married'}
            secondary={maritalStatus !== 'married'}
            onClick={() => handleSubmitMaritalStatus()}
          >
            配偶者あり
          </Button>
          <Button
            huge
            primary={maritalStatus === 'unmarried'}
            secondary={maritalStatus !== 'unmarried'}
            onClick={() => setValue('maritalStatus', 'unmarried')}
          >
            配偶者なし
            <br />
            （未婚・寡婦対象外）
          </Button>
          <Button
            huge
            primary={maritalStatus === 'divorced_or_bereavement'}
            secondary={maritalStatus !== 'divorced_or_bereavement'}
            onClick={() => setValue('maritalStatus', 'divorced_or_bereavement')}
          >
            配偶者なし
            <br />
            （その他）
          </Button>
        </ButtonContainer>
      </WidowTemplate.CheckSpouse>
      {maritalStatus && maritalStatus !== 'married' && (
        <WidowTemplate.CheckWidow>
          <ButtonContainer>
            <Button
              huge
              primary={classification === 'none'}
              secondary={classification !== 'none'}
              onClick={() => handleSubmitClassification('none')}
            >
              対象外
            </Button>
            <Button
              huge
              primary={classification === 'single_parent'}
              secondary={classification !== 'single_parent'}
              onClick={() => handleSubmitClassification('single_parent')}
            >
              ひとり親
            </Button>
            {profile.gender === 'female' && maritalStatus === 'divorced_or_bereavement' && (
              <Button
                huge
                primary={classification === 'normal'}
                secondary={classification !== 'normal'}
                onClick={() => handleSubmitClassification('normal')}
              >
                寡婦
              </Button>
            )}
          </ButtonContainer>
        </WidowTemplate.CheckWidow>
      )}
    </WidowTemplate>
  );
};
